// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleTypeReferenceShape = {
    primitive: (value) => {
        return {
            primitive: value,
            type: "primitive",
            _visit: function (visitor) {
                return FernIr.ExampleTypeReferenceShape._visit(this, visitor);
            },
        };
    },
    container: (value) => {
        return {
            container: value,
            type: "container",
            _visit: function (visitor) {
                return FernIr.ExampleTypeReferenceShape._visit(this, visitor);
            },
        };
    },
    unknown: (value) => {
        return {
            unknown: value,
            type: "unknown",
            _visit: function (visitor) {
                return FernIr.ExampleTypeReferenceShape._visit(this, visitor);
            },
        };
    },
    named: (value) => {
        return Object.assign(Object.assign({}, value), { type: "named", _visit: function (visitor) {
                return FernIr.ExampleTypeReferenceShape._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "primitive":
                return visitor.primitive(value.primitive);
            case "container":
                return visitor.container(value.container);
            case "unknown":
                return visitor.unknown(value.unknown);
            case "named":
                return visitor.named(value);
            default:
                return visitor._other(value);
        }
    },
};
